import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';


const HowMuchSection: FC<{}> = () => {
  const { width } = useResizeObserver();
  const { transData } = useTranslation('prices.howMuch');

  return (
    <section className={ styles['ac-how-much'] } id='how-much'>
      <div className={ styles['ac-how-much-container'] }>
        { width < 1192 && <div className={ styles['ac-how-much-content'] }>
          <div dangerouslySetInnerHTML={ { __html: transData.title } } />
        </div> }
        <div className={ styles['how-much-img'] }>
          <img className={ styles['how-much-img-1'] } loading='lazy'
               src='https://web-data.zmlearn.com/image/uMmzs91fVFnV37yatAQqsa/img_P1%402x.png'
               alt='' />
        </div>
        <div className={ styles['ac-how-much-content'] }>
          { width >= 1192 && (<div dangerouslySetInnerHTML={ { __html: transData.title } } />) }
          <p>{ transData.desc }</p>
        </div>
      </div>
    </section>
  );

};

export default HowMuchSection;
